import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { SETTINGS_PAGE_MAX_WIDTH } from 'src/constants/uiConsts';
import {
  SettingsPageToolbarContext,
  SettingsPageToolbarContextInterface,
} from 'src/context/settingsPageToolbarContext';

import { SettingsPageToolbar } from './SettingsPageToolbar';

import { SettingsPageRow } from '.';

const useStyles = makeStyles<{ drawerWidth: number }>()((theme, props) => ({
  settingsPageContent: {
    height: 'auto',
    width: '100%',
    maxWidth: SETTINGS_PAGE_MAX_WIDTH,
    margin: '0 auto',
    // mobile devices
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(5, 2),
      overflowY: 'auto',
    },
    // tablet devices
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(5, 4.5),
    },
    // desktop devices
    [theme.breakpoints.up('md')]: {
      paddingLeft: props.drawerWidth + parseInt(String(theme.spacing(10)), 10),
      paddingTop: theme.spacing(5),
    },
  },
}));

interface SettingsPageContentProps {
  children?: React.ReactNode;
  drawerWidth: number;
}

export const SettingsPageContent: React.FC<SettingsPageContentProps> = ({
  children,
  drawerWidth,
}) => {
  const { classes } = useStyles({ drawerWidth });
  const [toolbarActions, setToolbarActions] =
    React.useState<React.ReactNode>(null);

  const toolbarContextValue =
    React.useMemo<SettingsPageToolbarContextInterface>(
      () => ({ toolbarActions, setToolbarActions }),
      [toolbarActions],
    );

  return (
    <div className={classes.settingsPageContent}>
      <SettingsPageToolbarContext.Provider value={toolbarContextValue}>
        <SettingsPageRow fullHeight description={<SettingsPageToolbar />}>
          {children}
        </SettingsPageRow>
      </SettingsPageToolbarContext.Provider>
    </div>
  );
};
